import React, { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import VideoSelect from '../../Components/VideoSelect/VideoSelect';
import { useAddQuizMutation } from '../../features/quiz/quizApi';
import useGetUnUsedVideoId from '../../Hooks/useGetUnUsedVideoId';
import createOptionData, { correctIdString } from '../../utilities/CreateOptionData';
import CreateSingleOptions from './CreateSingleOptions';

const AddQuiz = () => {
    const navigate = useNavigate()
    const numArray = useMemo(() => [1, 2, 3, 4], [])
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const { uniqIdVideos, isLoading: isVideoLoading } = useGetUnUsedVideoId({ extraId: undefined, shouldGiveAllId: true })
    const [addQuiz, { isLoading, isSuccess, isError }] = useAddQuizMutation()
    const onSubmit = data => {
        const mainData = createOptionData(data, uniqIdVideos)
        addQuiz(mainData)
    };

    useEffect(() => {
        if (isSuccess) {
            navigate('/admin/quizzes')
            toast.success('Successfully added')
        }
        if (isError) {
            toast.error('something went wrong')
        }

    }, [isSuccess, isError, navigate])

    let content = null
    if (isVideoLoading) {
        content = <div>Loading...</div>
    } else {
        content = <form className='w-1/2 form-wrap' onSubmit={handleSubmit(onSubmit)}>
            <label>Question:</label>
            <input className='login-input mb-2' {...register("question", { required: true })} />

            <div className='grid grid-cols-2 gap-5 mt-5'>
                {
                    numArray.map(num => <CreateSingleOptions key={num} watch={watch} register={register} num={num} ></CreateSingleOptions>)
                }
                <div className='text-red-600'>
                    {errors[correctIdString(1)] ? 'Please select at least one correct ans!' : null}

                </div>
            </div>
            <div className="mt-5">
                <VideoSelect uniqIdVideos={uniqIdVideos} register={register}></VideoSelect>
            </div>
            <button disabled={isLoading} type='submit' className='mt-5 border-blue-300 border rounded-md px-2 py-2'>Add Quiz</button>
        </form>
    }
    return (
        <div className='flex justify-center'>
            {content}
        </div>
    );
};

export default AddQuiz;